<template>
    <div>
        <Panel
            :title="$t('User Groups')"
            :add-button="$store.hasRight('ADD_USER_GROUPS') ? $t('Add') : ''"
            :delete-button="selected.length > 0"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="usergroups_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('User Group Name') }}</th>
                        <th>{{ $t('Parent User Group') }}</th>
                        <th v-if="$store.hasRight('DELETE_USER_GROUPS')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="group in items" @click="(evt) => handleOpen(group.userGroupId, evt)">
                        <td class="primary">
                            {{ group.name }}
                        </td>
                        <td>
                            {{
                                group.parentId > 0 && items.some((x) => x.userGroupId === group.parentId)
                                    ? items.find((x) => x.userGroupId === group.parentId).name
                                    : ''
                            }}
                        </td>
                        <td v-if="$store.hasRight('DELETE_USER_GROUPS')">
                            <cic-checkbox
                                :value="selected.indexOf(group.userGroupId) !== -1"
                                @click="handleSelected(group.userGroupId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditUserGroup
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            :countries="countries"
            :groups="items"
            :areas="areas"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import Panel from '@/components/container/Panel';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, post, save } from '@/utils/Http';
    import EditUserGroup from './EditUserGroup';
    import { showValidationMessage } from '@/utils/Notification';

    export default {
        name: 'UserGroups',
        components: {
            Panel,
            EditUserGroup,
            CicCheckbox,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                selected: [],
                areas: {},
                countries: [],
            };
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('usergroups/delete', { groupIds: this.selected }, this.loadTable);
            },

            loadTable() {
                this.selected = [];
                this.closePopup();
                load('usergroups/get', {}, (response) => {
                    this.items = response.userGroups;
                });
            },

            openForm(groupId) {
                if (this.countries.length === 0) {
                    load('countries/get', {}, (response) => {
                        this.countries = response.countries;
                    });
                }

                const group = groupId > 0 ? this.items.find((x) => x.userGroupId === groupId) : { countryId: 1 };
                if (!Object.keys(this.areas).includes(`_${group.countryId}`)) {
                    load('localareas/get', { countryId: group.countryId }, (response) => {
                        this.areas[`_${group.countryId}`] = response.areas;
                    });
                }

                this.item = { ...group };
            },

            saveItem() {
                if (this.item.name.trim() === '') {
                    showValidationMessage('User Group Name is a required field');
                    return;
                }

                save('usergroup/update', { ...this.item }, this.loadTable);
            },

            updateFieldValue(field, value) {
                let item = { ...this.item };
                item[field] = value;
                this.item = item;
                if (field === 'countryId') {
                    item.localAreaId = null;
                    if (!Object.keys(this.areas).includes(`_${value}`)) {
                        post('localareas/get', { countryId: value }, (response) => {
                            const areas = { ...this.areas };
                            areas[`_${value}`] = response.areas;
                            this.areas = areas;
                        });
                    }
                }
            },
        },
    };
</script>
